module.exports = __webpack_public_path__ + "static/media/mono_manual_schematic_patch_2.f9468db2.svg";